import { HeroSection } from './sections/HeroSection';
import { HowItWorksSection } from './sections/HowItWorksSection';
import { PricingSection } from './sections/PricingSection';
import { HomeownersSection } from './sections/HomeownersSection';
import { OperatorsSection } from './sections/OperatorsSection';
import { SocialProofSection } from './sections/SocialProofSection';
import { TrustSection } from './sections/TrustSection';
import { DownloadSection } from './sections/DownloadSection';
import { FAQSection } from './sections/FAQSection';
import { SEO, SEO_CONFIG } from '@/components/primitives/SEO';

export function HomePage() {
  return (
    <>
      <SEO {...SEO_CONFIG.home} />
      <HeroSection />
      <HowItWorksSection />
      <PricingSection />
      <HomeownersSection />
      <OperatorsSection />
      <SocialProofSection />
      <TrustSection />
      <DownloadSection />
      <FAQSection />
    </>
  );
}

